/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import cn from 'clsx';
import { AModal, AButton } from 'components/Antd';
import T from 'i18n-react';
import { getFields } from 'views/DocumentManagement/components/SelectEntityModal/utils';
import AddBlock from './AddBlock';
import EntityBlock from './EntityBlock';
import SelectEntityModal from '../SelectEntityModal';
import { ENTITIES, ENTITY_DATA_KEY_MAPPING } from './constants';
import classes from './SaveToModal.module.scss';

const SaveToModal = ({
  open,
  onClose,
  selectedRows,
  onSubmit,
  defaultSelectedDocument,
  hasSetData,
}) => {
  const tSelectedRows = selectedRows || [];
  const [selectEntity, setSelectEntity] = useState('');
  const [selectedEntities, setSelectedEntities] = useState({});
  const entities = [ENTITIES.SUPPLIER, ENTITIES.FACTORY, ENTITIES.PRODUCT];
  let hasSelected = false;
  entities.forEach((entity) => {
    if (!!selectedEntities[entity]?.length) {
      hasSelected = true;
    }
  });

  useEffect(() => {
    if (!isEmpty(defaultSelectedDocument)) {
      const newSelectedEntities = {};
      entities.forEach((entity) => {
        const dataKey = ENTITY_DATA_KEY_MAPPING[entity];
        const tItems = defaultSelectedDocument[dataKey] || [];
        if (tItems.length) {
          newSelectedEntities[entity] = tItems;
        }
      });
      setSelectedEntities(newSelectedEntities);
    }
  }, []);

  return (
    <>
      <AModal
        title={hasSetData ? 'Save To & Set Data' : 'Save To'}
        open={open}
        onCancel={onClose}
        closable
        width={700}
        className={cn(classes.modalWrapper)}>
        <div className={classes.content}>
          <p>Selected Document: {tSelectedRows.map((obj) => obj.name).join(', ')}</p>
          <div className={classes.entities}>
            {entities.map((entityValue) => {
              const selectedEntityItems = selectedEntities[entityValue] || [];
              return (
                <React.Fragment key={entityValue}>
                  <AddBlock
                    entity={entityValue}
                    onClick={() => {
                      setSelectEntity(entityValue);
                    }}
                  />
                  {selectedEntityItems.map((obj) => {
                    const tFields = getFields(entityValue, obj, true);
                    return (
                      <EntityBlock
                        fields={tFields}
                        name={obj.name}
                        data={{
                          ...obj,
                          status: obj.isActive === false ? 'inactive' : 'active',
                        }}
                        key={obj.id}
                        entity={entityValue}
                        onSelectChanged={() => {
                          setSelectedEntities({
                            ...selectedEntities,
                            [entityValue]: selectedEntityItems.filter((item) => item.id !== obj.id),
                          });
                        }}
                      />
                    );
                  })}
                </React.Fragment>
              );
            })}
          </div>
        </div>
        <div className={classes.footer}>
          <AButton
            onClick={() => {
              if (onSubmit) onSubmit(selectedEntities);
            }}
            htmlType="button"
            type="primary"
            size="large"
            disabled={!hasSelected}
            className={classes.confirmBtn}>
            Confirm
          </AButton>
        </div>
      </AModal>
      {!!selectEntity && (
        <SelectEntityModal
          open
          onClose={() => {
            setSelectEntity('');
          }}
          entity={selectEntity}
          onSubmit={(tSelectedItems) => {
            setSelectedEntities({
              ...selectedEntities,
              [selectEntity]: tSelectedItems,
            });
            setSelectEntity('');
          }}
          defaultSelectedItems={selectedEntities[selectEntity] || []}
        />
      )}
    </>
  );
};

export default SaveToModal;
